/* Optional marker images on the Torso artwork metaobject, one per fabric
   (front_marker_aerodynamic / front_marker_performance_silk): the design's artwork
   with a pale-red box (about #FF4747) where the emblem or initials go. When the
   selected fabric has one, the box sets that placement in place of the built-in
   EMBLEM_POS numbers: its centre moves the emblem (dx / dyFromTop) and the initials
   (textDx / textDyFromTop), and its width sizes the emblem (rf). The initials font
   size is left alone. Blank, still loading or unusable -> QZMarker.pos() returns null
   and sections/quinella-customizer.liquid keeps using EMBLEM_POS exactly as before.
   Fires "qz-marker" on window when one finishes loading so the preview redraws.
   The fabric is matched by role (Aerodynamic, or the performance fabric under
   whatever name it carries), so renaming the variant does not break it. */
(function () {
  var P = {},
    ROLES = ['aerodynamic', 'performance-silk'];
  function art() {
    return (window.QUINELLA_DATA && window.QUINELLA_DATA.torsoArt) || {};
  }
  function roleOf(fabricName) {
    return fabricName ? (/aero/i.test(fabricName) ? 'aerodynamic' : 'performance-silk') : '';
  }
  function load(name, role) {
    var key = name + '|' + role;
    if (key in P) return;
    P[key] = null;
    var e = art()[name],
      m = e && e.marker && e.marker[role],
      url = m && m.front;
    if (!url) return;
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        var w = img.naturalWidth,
          h = img.naturalHeight;
        if (!w || !h || Math.abs(w / h / (3000 / 3482) - 1) > 0.02) return; /* not the artwork shape */
        var c = document.createElement('canvas');
        c.width = w;
        c.height = h;
        var g = c.getContext('2d');
        g.drawImage(img, 0, 0);
        var px = g.getImageData(0, 0, w, h).data,
          x0 = w, x1 = -1, y0 = h, y1 = -1, n = 0;
        for (var y = 0; y < h; y++) {
          for (var x = 0; x < w; x++) {
            var i = (y * w + x) * 4;
            /* pale red: green and blue about equal; the orange reference horse has far less blue than green */
            if (px[i + 3] > 128 && px[i] > 200 && px[i + 1] > 50 && px[i + 1] < 130 && px[i + 2] > 50 && px[i + 2] < 130 && Math.abs(px[i + 1] - px[i + 2]) < 25) {
              n++;
              if (x < x0) x0 = x;
              if (x > x1) x1 = x;
              if (y < y0) y0 = y;
              if (y > y1) y1 = y;
            }
          }
        }
        var k = 3000 / w,
          bw = (x1 - x0 + 1) * k,
          bh = (y1 - y0 + 1) * k;
        if (n < 500 || bw < 40 || bh < 40 || bw > 1600 || bh > 2000) return; /* no usable box */
        /* the hollow inside a frame (Diamond frame) is a kite; only designs named "...frame" have one, so no other design does this work.
           A box that sits inside the hollow: filling out from the box centre (through transparent or red pixels) finds all four tips.
           A box that is bigger (it covers the hollow's middle and part of the frame): that fill runs out into the open, so the left, right and bottom
           tips are found from the transparent areas beside and below the box, and the top tip is the box's top edge.
           cav = the kite shrunk by 1 (the cover must not touch the frame),
           maxTfs = the biggest font whose letter (cap 0.72 x font, width up to 1.15 x cap, centred on the box) stays inside the kite with a 7% margin. */
        var cav = null, maxTfs = null;
        if (/frame/i.test(name)) {
          var mx = Math.round((x0 + x1) / 2), my = Math.round((y0 + y1) / 2), seen = new Uint8Array(w * h);
          var flood = function (sx, sy, red, cap) {
            if (sx < 0 || sy < 0 || sx >= w || sy >= h) return null;
            seen.fill(0);
            var st = [sx, sy], e = { l: [sx, sy], r: [sx, sy], t: [sx, sy], b: [sx, sy] }, cnt = 0;
            while (st.length && cnt < cap) {
              var yy = st.pop(), xx = st.pop();
              if (xx < 0 || yy < 0 || xx >= w || yy >= h) continue;
              var ii = yy * w + xx, a = ii * 4;
              if (seen[ii]) continue;
              if (px[a + 3] > 128 && !(red && px[a] > 200 && px[a + 1] > 50 && px[a + 1] < 130 && px[a + 2] > 50 && px[a + 2] < 130 && Math.abs(px[a + 1] - px[a + 2]) < 25)) continue;
              seen[ii] = 1;
              cnt++;
              if (xx < e.l[0]) e.l = [xx, yy];
              if (xx > e.r[0]) e.r = [xx, yy];
              if (yy < e.t[1]) e.t = [xx, yy];
              if (yy > e.b[1]) e.b = [xx, yy];
              st.push(xx + 1, yy, xx - 1, yy, xx, yy + 1, xx, yy - 1);
            }
            return cnt > 0 && cnt < cap ? e : null; /* a fill that runs on is not enclosed: no hollow */
          };
          var hol = flood(mx, my, true, 70000), V = null;
          if (hol) V = [hol.t, hol.r, hol.b, hol.l];
          else {
            var Lw = flood(x0 - 3, my, false, 20000), Rw = flood(x1 + 3, my, false, 20000), Bw = flood(mx, y1 + 3, false, 20000);
            if (Lw && Rw && Bw) V = [[Bw.b[0], y0], Rw.r, Bw.b, Lw.l];
          }
          if (V) {
            V = V.map(function (p) { return [p[0] * k, p[1] * k]; });
            var ccx = (V[0][0] + V[1][0] + V[2][0] + V[3][0]) / 4,
              ccy = (V[0][1] + V[1][1] + V[2][1] + V[3][1]) / 4,
              inside = function (s, X, Y) {
                var sg = 0;
                for (var j = 0; j < 4; j++) {
                  var a = V[j], b = V[(j + 1) % 4], ax = ccx + (a[0] - ccx) * s, ay = ccy + (a[1] - ccy) * s, bx = ccx + (b[0] - ccx) * s, by = ccy + (b[1] - ccy) * s,
                    cr = (bx - ax) * (Y - ay) - (by - ay) * (X - ax);
                  if (j === 0) sg = cr;
                  else if (cr * sg < 0) return false;
                }
                return true;
              },
              bxc = ((x0 + x1 + 1) / 2) * k, byc = ((y0 + y1 + 1) / 2) * k;
            maxTfs = 120;
            for (var t = 120; t <= 700; t += 4) {
              var hw = 0.575 * 0.72 * t, hh = 0.5 * 0.72 * t;
              if (inside(0.93, bxc - hw, byc - hh) && inside(0.93, bxc + hw, byc - hh) && inside(0.93, bxc - hw, byc + hh) && inside(0.93, bxc + hw, byc + hh)) maxTfs = t;
              else break;
            }
            cav = [];
            V.forEach(function (p) {
              var dx = ccx - p[0], dy = ccy - p[1], d = Math.sqrt(dx * dx + dy * dy) || 1;
              cav.push(p[0] + dx / d, p[1] + dy / d);
            });
          }
        }
        P[key] = { cx: ((x0 + x1 + 1) / 2) * k, cy: ((y0 + y1 + 1) / 2) * k, bw: bw, bh: bh, top: y0 * k, bot: (y1 + 1) * k, cav: cav, maxTfs: maxTfs };
        window.dispatchEvent(new Event('qz-marker'));
        reach(name, role, key);
      } catch (err) {}
    };
    img.src = url;
  }
  /* Whatever size the marker box is drawn, the cover must hide the baked emblem. So measure, in the artwork itself, how far the orange
     emblem reaches from the box centre (a small copy of the artwork is enough) and never let the cover be smaller than that. */
  function reach(name, role, key) {
    var e = art()[name],
      f = e && e.fab && e.fab[role],
      url = (f && f.front) || (e && e.front);
    if (!url) return;
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () {
      try {
        var w = im.naturalWidth,
          h = im.naturalHeight,
          m = P[key],
          far = 0;
        if (!w || !h || !m) return;
        var c = document.createElement('canvas');
        c.width = w;
        c.height = h;
        var g = c.getContext('2d');
        g.drawImage(im, 0, 0);
        var px = g.getImageData(0, 0, w, h).data,
          k = 3000 / w;
        for (var y = 0; y < h; y++) {
          for (var x = 0; x < w; x++) {
            var i = (y * w + x) * 4;
            if (px[i + 3] > 128 && px[i] > 180 && px[i + 1] < 130 && px[i + 2] < 70 && px[i] > px[i + 1] * 1.8) {
              var d = Math.sqrt(Math.pow(x * k - m.cx, 2) + Math.pow(y * k - m.cy, 2));
              if (d > far) far = d;
            }
          }
        }
        m.need = far ? far * 1.04 : 0; /* 0 = no orange emblem found: keep the box-based cover */
        window.dispatchEvent(new Event('qz-marker'));
      } catch (err) {}
    };
    im.src = url.replace(/width=\d+/, 'width=750');
  }
  /* the red box as placement numbers for torso frame f and the selected fabric, or null to keep EMBLEM_POS */
  window.QZMarker = {
    pos: function (name, f, fabricName) {
      var role = roleOf(fabricName);
      if (!role) return null;
      load(name, role);
      var m = P[name + '|' + role];
      if (!m) return null;
      var dx = (m.cx - f.cx) / (f.x1 - f.x0),
        dy = (m.cy - f.y0) / (f.y1 - f.y0);
      /* the logo is fitted inside a square of side 1.414 x radius, so a box that wide needs radius = width / 1.414 */
      var H = f.y1 - f.y0;
      /* coverR: the circle that hides the baked emblem. The placeholder reaches only 0.71-0.76 of the box's half-diagonal in every design,
         so 0.78 hides it while staying inside the disk / ring around it (the old 1.15 x radius overshot a smaller disk).
         colTopFrac / colBotFrac: the Braces letter column, read only by the Braces initials. */
      return {
        dx: dx, dyFromTop: dy, rf: m.bw / Math.SQRT2 / f.r, textDx: dx, textDyFromTop: dy,
        coverR: m.need || (Math.sqrt(m.bw * m.bw + m.bh * m.bh) / 2) * 0.78, /* the measured reach of the emblem when known, else 0.78 x the box */
        colTopFrac: (m.top - f.y0) / H, colBotFrac: (m.bot - f.y0) / H,
        /* boxW: the initials' cover is never wider than the letter slot, so its corners cannot nick the design around the letters */
        boxW: m.bw,
        /* textW: the placeholder letters fill the slot width (the box is about 1.07 x the letters' width in every design measured); the section turns it into the font size */
        textW: m.bw / 1.07,
        /* cav / maxTfs: only used by the Diamond frame (family flag "cavity" in the section) - see where they are measured above */
        cav: m.cav,
        maxTfs: m.maxTfs,
      };
    },
  };
  /* start reading every marker at load so the first draw is already right */
  function start() {
    Object.keys(art()).forEach(function (name) {
      ROLES.forEach(function (role) {
        load(name, role);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
